import {Pipe, PipeTransform} from '@angular/core';
import {UtilsHelper} from '../helpers/utils.helper';
import {AbstractControl, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

@Pipe({
    name: 'isNilOrEmpty',
    standalone: false
})
export class IsNilOrEmpty implements PipeTransform {

  transform(value: any): boolean {
    return UtilsHelper.IsNilOrEmpty(value);
  }

}

@Pipe({
    name: 'sortByKey',
    standalone: false
})
export class SortByKeyPipe implements PipeTransform {

  transform<T>(value: T[], key: string, order: string = 'asc'): T[] {
    if (!Array.isArray(value) || !key) {
      return value;
    }
    const arrayToSort = [...value]
    arrayToSort.sort((a, b) => a[key] > b[key] ? 1 : -1 );
    return order === 'asc' ? arrayToSort : arrayToSort.reverse();
  }

}

@Pipe({
    name: 'asFormGroup',
    standalone: false
})
export class AsFormGroup implements PipeTransform {

  transform(value: any & AbstractControl) {
    return value as UntypedFormGroup;
  }

}

@Pipe({
    name: 'asFormControl',
    standalone: false
})
export class AsFormControl implements PipeTransform {

  transform(value: any & AbstractControl) {
    return value as UntypedFormControl;
  }

}

@Pipe({
    name: 'getHumanFormatedDate',
    standalone: false
})
export class GetHumanFormatedDate implements PipeTransform {

  transform(date: Date) {
    return UtilsHelper.getHumanFormatedDate(date);
  }

}

@Pipe({
    name: 'filter',
    standalone: false
})
export class Filter implements PipeTransform {

  transform<T>(array: T[], key: string, value: any): T[] {
    if (!key || !value) return array;
    return array.filter((v) => v[key] === value);
  }
}

@Pipe({
    name: 'isPrimitive',
    standalone: false
})
export class IsPrimitive implements PipeTransform {

  transform(value: any) {
    return value !== Object(value);
  }
}
